import ListAdministrators from "../../../../components/@users/administrators/ListAdministrators";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AdministratorsPage() {

    return (
        <ListAdministrators 
            routeType={routeTypes.admin}
        />
    )
}       